// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from 'informed';
import moment from 'moment';

import { getMonthlyReport } from '../../actions/monthlyReportActions';

// import ContentBox from '../ContentBox.jsx';
import Header from '../Header.jsx';
import RequiredText from '../RequiredText.jsx';
import { PrimaryButton } from '../Buttons.jsx';
import styles from '../../styles/MonthlyReportPage.scss';
import {
  renderTotalVisits, renderImaging, renderLabs, renderSpecialistAppointments, renderSurgeries,
  renderNewBabies, renderHospitalAdmissions, renderDietChanges, renderDiagnoses,
} from './monthlyReportUtil';

type Props = {
  data: Object,
  status: string,
  getMonthlyReport: Function,
}

// The page is rendered at the /monthlyReport endpoint.
class MonthlyReportPageComponent extends Component<Props> {
  formApi: {
    getState: Function,
    getValue: Function,
    setError: Function,
  }

  setFormApi = (formApi: Object) => {
    this.formApi = formApi;
  }

  getMonthlyReport = () => {
    const state = this.formApi.getState();
    if (state.invalid) {
      return;
    }
    if (!this.formApi.getValue('month')) {
      this.formApi.setError('month', 'Error');
      return;
    }
    if (!this.formApi.getValue('year')) {
      this.formApi.setError('year', 'Error');
      return;
    }
    const { month, year } = state.values;
    this.props.getMonthlyReport(month, year);
  }

  // Adapted magic from:
  // https://stackoverflow.com/questions/48554043/javascript-copy-element-to-clipboard-with-all-styles
  copyReportToClipboard = () => {
    // Temporarily change the background color so the output isn't all blue.
    const originalBackgroundColor = document.body.style.backgroundColor;
    document.body.style.backgroundColor = 'transparent';

    const doc = document;
    const text = doc.getElementById('data');
    let range;
    let selection;

    if (doc.body.createTextRange) {
      range = doc.body.createTextRange();
      range.moveToElement(text);
      range.select();
    } else if (window.getSelection) {
      selection = window.getSelection();

      range = doc.createRange();
      range.selectNodeContents(text);

      selection.removeAllRanges();
      selection.addRange(range);
    }

    document.execCommand('copy');
    window.getSelection().removeAllRanges();

    document.body.style.backgroundColor = originalBackgroundColor;
  }

  enter = ({ key }) => {
    if (key === 'Enter') {
      this.getMonthlyReport();
    }
  }

  render() {
    if (this.props.status === 'LOADING') {
      // TODO: Full page loading screen
      return 'Loading';
    }
    const { data } = this.props;
    return (
      <div>
        <Header />
        <div className={styles.monthlyReportPage}>
          <Form getApi={this.setFormApi} autoComplete='off'>
            <div onKeyPress={this.enter}>
              <table>
                <tbody>
                  <tr>
                    <td>Month: </td>
                    <td><RequiredText field='month' initialValue={''} /></td>
                  </tr>
                  <tr>
                    <td>Year: </td>
                    <td><RequiredText field='year' initialValue={''} /></td>
                  </tr>
                </tbody>
              </table>
              <div>
                <PrimaryButton onClick={this.getMonthlyReport}>Get Monthly Report</PrimaryButton>
              </div>
            </div>
          </Form>
          <hr />
          {data && <div>
            <PrimaryButton onClick={this.copyReportToClipboard}>Copy to Clipboard</PrimaryButton>
          </div>}
          {data
            && <div className={styles.monthlyReportTable} id='data'>
              <div>
                <h1>Monthly Report for {moment(data.month, 'M').format('MMMM')} {data.year}</h1>
                {renderTotalVisits(data.totalMonthVisits, data.totalYearVisits)}
                {renderLabs(data.labs, data.fbcCount, data.lftCount)}
                {renderImaging(data.imaging)}
                {renderSpecialistAppointments(data.specialistAppointments)}
                {renderSurgeries(data.surgeries)}
                {renderNewBabies(data.newBabies)}
                {renderHospitalAdmissions(data.hospitalAdmissions)}
                {renderDietChanges(data.dietChanges)}
                <div>
                  <h1>WCC: {data.wccCount}</h1>
                </div>
                <div>
                  <h1>IMM: {data.immunizationCount}</h1>
                </div>
                <div>
                  <h1>HB: {data.hbTestCount}</h1>
                </div>
                <div>
                  <h1>HIV Testing: {data.hivTestCount}</h1>
                </div>
                {renderDiagnoses('Acute', data.acuteDiagnoses)}
                {renderDiagnoses('Chronic', data.chronicDiagnoses)}
                <div>
                  <h1>Other</h1>
                </div>
              </div >
            </div >
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  data: state.monthlyReport.data,
  status: state.monthlyReport.status,
});

const mapDispatchToProps = dispatch => ({
  getMonthlyReport: (month, year) => dispatch(getMonthlyReport(month, year)),
});

const MonthlyReportPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MonthlyReportPageComponent);

export default MonthlyReportPage;



// WEBPACK FOOTER //
// ./client/src/components/monthlyReportPages/MonthlyReportPage.jsx